document.addEventListener('DOMContentLoaded', function () {
    const element = document.querySelector('.recommended-types-slider');
    if (!element || typeof Splide === 'undefined') return;

    const slider = new Splide(element, {
        pagination: true,
        trimSpace: 'move',
        focus: 0,
        arrows: false,
        drag: true,
        gap: '4px',
        fixedWidth: '205px',
        mediaQuery: 'min',
        breakpoints: {
            576: {
                fixedWidth: '215px',
                gap: '4px',
            },
            768: {
                fixedWidth: '225px',
                arrows: true,
            },
            992: {
                fixedWidth: '230px',
                gap: '4px',
            },
            1200: {
                fixedWidth: '235px',
            },
        },
        classes: {
            arrows: 'splide__arrows recommended-types-slider__arrows',
            arrow: 'splide__arrow recommended-types-slider__arrow',
            prev: 'splide__arrow--prev recommended-types-slider__arrow--prev',
            next: 'splide__arrow--next recommended-types-slider__arrow--next',
            pagination: 'splide__pagination recommended-types-slider__pagination',
            page: 'splide__pagination__page recommended-types-slider__pagination-line',
        },
    });

    slider.mount();
});